import { fetch } from '@atlassian/eoc-fetch';
import { withAIOpsPrefix } from '../../common/utils';
export const getHeaderDetails = groupId => fetch(withAIOpsPrefix(`/v1/group-insights/${groupId}`), {
  exactUrl: true
});
export const getAISuggestions = groupId => fetch(withAIOpsPrefix(`/v1/group-insights/getSimilar/${groupId}`), {
  exactUrl: true
});
export const addGroupAssignee = (groupId, assigneeId) => fetch(withAIOpsPrefix(`/v1/group-insights/${groupId}/add-assignee/${assigneeId}`), {
  method: 'PUT',
  exactUrl: true
});
export const actionOnGroup = (groupId, action) => {
  return fetch(withAIOpsPrefix(`/v1/alert-insights/bulk-action`), {
    method: 'PUT',
    exactUrl: true,
    body: {
      groupId: groupId,
      actionType: action
    }
  });
};
export const getAlertCountForGroupAction = (groupId, action) => {
  const urlSearchParams = new URLSearchParams();
  urlSearchParams.set('actionType', action);
  urlSearchParams.set('groupId', groupId);
  return fetch(withAIOpsPrefix(`/v1/alert-insights/check-all-action?${urlSearchParams}`), {
    exactUrl: true
  });
};